import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import CApp from './CognitoApp';
import KApp from './KeycloakApp';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { DEPLOYMENT_REGION } from './utils/constants';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      {DEPLOYMENT_REGION === "USA" ? <CApp /> : <KApp />}
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
